import React from 'react';
import SweetAlert from 'react-bootstrap-sweetalert';

export default (props) => {

    const {inputProps, promocodeClose, promocodeConfirm, handlePromocode} = props;
    const {type, show, promocode, error} = inputProps;

    return (<SweetAlert
                type={type}
                show={show}
                confirmBtnCssClass="alert-btn-confirm"
                cancelBtnCssClass="alert-btn-cancel"
                showCancel={type === 'success' ? false : true}
                showConfirm
                confirmBtnText={type === 'success' ? "Готово" : "Продолжить"}
                cancelBtnText="Отменить"
                confirmBtnBsStyle="danger"
                cancelBtnBsStyle="default"
                title="Промокод"
                onConfirm={ () => type === 'success' ? promocodeClose() : promocodeConfirm() }
                onCancel={ () => promocodeClose() }
            >
                {
                    type === 'success'
                    ?
                    <div>
                        <label style={{display:'block'}}>Промокод активирован</label>
                    </div>
                    :
                    <div>
                        <label style={{display:'block'}}>{error || "Введите промокод" }</label>
                        <input
                            type="text"
                            style={{paddingLeft: '15px',borderRadius: '3px',border: '1px solid #ccc',fontSize: '14px',height: '38px',marginTop: '8px'}}
                            value={promocode} 
                            onChange={(e) => handlePromocode(e.target.value)}
                            />
                    </div>
                }
            </SweetAlert>)
}


// WEBPACK FOOTER //
// ./src/components/Account/Modals/Promocode.js